import { render, staticRenderFns } from "./MaterialAutoParse.vue?vue&type=template&id=0cf383e1&scoped=true"
import script from "./MaterialAutoParse.vue?vue&type=script&lang=js"
export * from "./MaterialAutoParse.vue?vue&type=script&lang=js"
import style0 from "./MaterialAutoParse.vue?vue&type=style&index=0&id=0cf383e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf383e1",
  null
  
)

export default component.exports